<script setup>
import Button from '@components/global/button.vue'
import { useGlobalStore } from '@stores/global'
import Input from '@components/global/input.vue'
import Textarea from '@components/global/textarea.vue'
const global = useGlobalStore()
</script>
<template>
	<section class="container flex max-w-[800px] flex-col items-center md:mt-40">
		<img src="https://hennep.s3.amazonaws.com/above/images/home/merch/element.svg" alt="" class="absolute right-0 top-0 hidden mix-blend-color md:block" />
		<div class="relative flex flex-col items-center gap-10">
			<div class="font-body text-body-sm font-medium uppercase tracking-wider text-text-base">contact us</div>
			<div class="w-full text-center font-heading text-h2 font-medium uppercase leading-[0.8] text-text-muted md:text-display-sm">
				contact made.
				<br />
				mind elevated.
			</div>
			<div class="w-half self-end font-body text-body-sm font-medium uppercase tracking-wider text-text-base">Excepteur do minim eu ad eu anim quis qui elit non ullamco.</div>
			<img src="https://hennep.s3.amazonaws.com/above/images/home/products/planet.png" class="absolute right-0 top-0 aspect-video max-w-[120px] rotate-45 md:right-[-30%]" alt="" />
			<img src="https://hennep.s3.amazonaws.com/above/images/home/products/planet2.png" class="absolute bottom-[10%] left-0 aspect-square max-w-[80px] md:-left-[10%]" alt="" />
		</div>

		<form class="mt-10 flex w-full flex-col gap-6 md:mt-20">
			<Input label="Name" placeholder="Insert your full name" />
			<Input label="Email" placeholder="Insert email" />
			<Input label="Message" placeholder="Insert phone" />
			<Textarea label="Message" placeholder="Insert your message" />
			<Button class="btn-outline big mt-10 md:mt-20"><h3>send a signal</h3></Button>
		</form>
	</section>
</template>
<style scoped></style>
